module.exports = __webpack_public_path__ + "static/media/dogood-main-image.d86a985e.png";